export default __webpack_public_path__ + "static/media/pos-banner.5d429f86.webp";